interface AuthClientConfigResponse {
    readonly useCustomAuthUi: boolean;
}

enum AUTH_FLOW_TYPE {
    CUSTOM = 'custom',
    HOSTED = 'hosted',
}

export type { AuthClientConfigResponse };
export { AUTH_FLOW_TYPE };
